/*eslint-disable */
import { FIELD_IDS_TO_DISPLAY_NAME , 
    FIELD_TO_COLUMN_INDEX_FOR_NEW_USER, 
    FIELD_TO_COLUMN_INDEX_FOR_REACTIVATE_USER, FIELD_IDS_TO_ERROR_MESSAGE } from './warningsModal.constants';
import { REACTIVATION_TEMPLATE } from "../../bulkUsersUpload.constants";


export const getFieldName = (field, uploadType) => {
    const displayName = FIELD_IDS_TO_DISPLAY_NAME[field];
    let columnIndex = FIELD_TO_COLUMN_INDEX_FOR_NEW_USER[field];
    if(REACTIVATION_TEMPLATE.id == uploadType) {
      columnIndex = FIELD_TO_COLUMN_INDEX_FOR_REACTIVATE_USER[field]; 
    }
    return `Column ${columnIndex}: ${displayName}`
}

export const getErrorMessageForField = field => FIELD_IDS_TO_ERROR_MESSAGE[field]